
import {Fill, Icon, RegularShape, Stroke, Style, Text} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {hexToRgba} from "@/helpers/color-helper";
import {getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {getDefaultStyle} from "ol/format/KML";
import {getDefaultStyleFunction, getDefaultStyles} from "@/helpers/ol/ol-style-helper.js";

export function getWfsStyle(wfsStyle, withCluster = false, hoverValue = false, select = false, feature = undefined) {
    const attribute = wfsStyle.attribute

    let style = {}

    let hoverStyle = null
    style.style = {}
    style.selection = {}

    style.selection = new Style({
        image: new CircleStyle({
            radius: wfsStyle.SelectPointRadius,
            fill: new Fill({
                color: 'rgba(' + hexToRgba(wfsStyle.SelectFillColor, wfsStyle.SelectFillOpacity) + ')'
            }),
            stroke: new Stroke({
                color: 'rgba(' + hexToRgba(wfsStyle.SelectStrokeColor, wfsStyle.SelectStrokeOpacity) + ')',
                width: wfsStyle.SelectStrokeWidth,
            }),
        }),
        fill: new Fill({
            color: 'rgba(' + hexToRgba(wfsStyle.SelectFillColor, wfsStyle.SelectFillOpacity) + ')'
        }),
        stroke: new Stroke({
            color:  wfsStyle.SelectStrokeColor,
            width: 1,
        }),
        text: new Text({
            text: wfsStyle.SelectLabel,
            stroke: new Stroke({
                color: 'rgba(' + hexToRgba(wfsStyle.SelectLabelOutlineColor, 1) + ')',
                width: wfsStyle.SelectLabelOutlineWidth,
            }),
            fill: new Fill({
                color: 'rgba(' + hexToRgba(wfsStyle.SelectFontColor, 1) + ')',
            }),
            offsetX: wfsStyle.SelectLabelXOffset,
            offsetY: wfsStyle.SelectLabelYOffset,
            scale: wfsStyle.SelectFontSize / 5,
        })
    })

    let styles = {}

    if(Array.isArray(wfsStyle.styles)) {
        wfsStyle.styles.map(wfsStyle => {
            let styleItem = generateStyle(wfsStyle, hoverValue, attribute, style, styles, select, feature)
            styles = styleItem.styles
            style = styleItem.style
        })
    } else {
        style = generateSingleStyle(wfsStyle.styles, hoverValue, select)
    }

    if(hoverValue) {
        return style
    }

    if (attribute) {
        if(withCluster) {
            return styles
        } else {
            return function (feature) {
                return styles[feature.values_[attribute]];
            }
        }
    }

    return style
}

export function updateWfsStyle(bookmarkPresentation, attribute, categories) {

    const layer = getLayerByName(bookmarkPresentation.ID)

    if(layer) {
        const wfsStyle = {}
        wfsStyle.styles = bookmarkPresentation.WfsStyle.styles.filter(style => categories.includes(String(style.Value)))

        console.log(bookmarkPresentation.WfsStyle.styles)
        console.log(wfsStyle.styles )

        wfsStyle.attribute = bookmarkPresentation.WfsStyle.attribute

        if(wfsStyle.styles.length === 0 || bookmarkPresentation.WfsStyle.styles.length <= 1) {
            categories.map((category) => {
                wfsStyle.styles.push({
                    Name: category,
                    Value: category,
                    style_settings: bookmarkPresentation.WfsStyle.styles[0].style_settings
                })
            })
        }

        const styleCluster = getWfsStyle(wfsStyle, true)
        const styleClusterClone = getWfsStyle(wfsStyle, true)

        let styleClone

        layer.setStyle((feature) => {

            let style
            styleClone = null

            if(wfsStyle.attribute) {
                style = styleCluster[feature.values_[wfsStyle.attribute]];
                styleClone = styleClusterClone[feature.values_[wfsStyle.attribute]];
            }

            if(!style) {
                return
            }

            if(styleClone) {
                if (typeof styleClone.getText !== "undefined" && styleClone.getText()) {
                    let textObject = styleClone.getText().getText()
                    if (textObject.includes("${")) {
                        textObject = textObject.replace("${", '').replace('}', '')

                        if (feature.get(textObject)) {
                            style.getText().setText(feature.get(textObject).toString())
                        }
                    }
                }
            }

            return style
        })
    }
}

export function generateStyle(wfsStyle, hoverValue, attribute, style, styles, select = false, feature = undefined) {
    let externalGraphic = wfsStyle.style_settings.externalGraphic

    if(select) {
        externalGraphic = wfsStyle.style_settings.SelectExternalGraphic
    }

    if(externalGraphic.includes('${')) {
        const regex = /\${(.*?)}/g;
        let match;

        while ((match = regex.exec(externalGraphic)) !== null) {
            let value = feature.get(match[1])
            if(value === '-') {
                value = ''
            }
            externalGraphic = externalGraphic.replace('${' + match[1] + '}', value.toString())
        }
    }

    let newStyle = generateSingleStyle(wfsStyle.style_settings, hoverValue, select)

    if(externalGraphic === null || externalGraphic === '') {

        if (attribute === null) {
            style = newStyle
        } else {
            if(hoverValue === wfsStyle.Value) {
                style = newStyle
            }
            styles[wfsStyle.Value] = newStyle
        }

    } else {

        let imageSrc = ''
        if(externalGraphic.includes('.svg')) {
            const request = new XMLHttpRequest();
            request.open('GET', externalGraphic, false);  // `false` makes the request synchronous
            try {
                request.send(null);
            } catch (e) {
                console.error(`Afbeelding ${externalGraphic} kan niet opgehaald worden`)
            }

            let workingSvg = ''
            if (request.status === 200) {
                workingSvg = request.responseText

                // Add circle when fill color is white
                if(workingSvg.includes('style="fill:#FFFFFF;"') || workingSvg.includes('fill:#fff;')) {

                    const viewBoxSplit = workingSvg.split(' viewBox="')[1]
                    const viewBox = viewBoxSplit.substring(0, viewBoxSplit.indexOf('"')).split(' ')

                    const dimX = parseInt(viewBox[2]) - parseInt(viewBox[0])
                    const dimY = parseInt(viewBox[3]) - parseInt(viewBox[1])

                    let radius
                    if(dimX > dimY) {
                        radius = dimX / 2
                    } else {
                        radius = dimY / 2
                    }

                    const midX = viewBox[2] - (dimX / 2)
                    const midY = viewBox[3] - (dimY / 2)

                    let fillColor = wfsStyle.style_settings.fillColor
                    if(select) {
                        fillColor = wfsStyle.style_settings.SelectFillColor
                    }

                    const circle = '<circle style="fill:' + fillColor + ';" r="' + radius + '" cy="' + midY + '" cx="' + midX + '"/>'
                    workingSvg = workingSvg.replace('<path', circle + '<path')
                }

                // Remove width and height
                workingSvg = workingSvg.replace('width="', 'test="')
                workingSvg = workingSvg.replace('height="', 'test2="')
                // Set with width and height to 5
                workingSvg = workingSvg.replace('<svg', '<svg width="5" height="5"')
                workingSvg = workingSvg.split("<svg")[1];

                workingSvg = '<svg' + workingSvg
            }

            imageSrc = 'data:image/svg+xml;utf8,' + encodeURIComponent(workingSvg)
        } else {
            imageSrc = externalGraphic
        }

        let scale = wfsStyle.style_settings.pointRadius
        if(externalGraphic.includes('.png')) {
            scale = scale / 10
        } else {
            scale = scale - 8
        }

        if(hoverValue === wfsStyle.Value) {
            if(externalGraphic.includes('.png')) {
                scale = scale + 0.5
            } else {
                scale = scale + 2
            }
        } else {

        }

        if(select) {
            scale = wfsStyle.style_settings.SelectPointRadius

            if(externalGraphic.includes('.png')) {
                scale = scale / 10
            } else {
                scale = scale - 8
            }
        }

        if (attribute === null) {
            style =
                new Style({
                    // Allow icons for polygon or multipolygon
                    geometry: function(feature) {
                        let geometry = feature.getGeometry();
                        let geometryType = geometry.getType();
                        return (
                            geometryType === 'Polygon' ? geometry.getInteriorPoint() :
                                geometryType === 'MultiPolygon' ? geometry.getInteriorPoints() :
                                    geometry
                        );
                    },
                    image: new Icon({
                        scale: scale,
                        opacity: 1,
                        src: imageSrc
                    }),
                })
        } else {


            let categoryStyle = new Style({
                // Allow icons for polygon or multipolygon
                geometry: function(feature) {
                    let geometry = feature.getGeometry();
                    let geometryType = geometry.getType();
                    return (
                        geometryType === 'Polygon' ? geometry.getInteriorPoint() :
                            geometryType === 'MultiPolygon' ? geometry.getInteriorPoints() :
                                geometry
                    );
                },
                image: new Icon({
                    scale: scale / 1.5,
                    opacity: 1,
                    src: imageSrc
                })
            })

            if(hoverValue === wfsStyle.Value) {
                style = categoryStyle
            }

            styles[wfsStyle.Value] = categoryStyle
        }
    }

    return {
        'styles': styles,
        'style': style
    }
}

export function generateSingleStyle(style, hoverValue, select = false) {

    let radius = style.pointRadius
    if(hoverValue) {
        radius = radius + 4
    }

    // console.log(style)

    if(style.fillColor.includes('${')) {
        style.fillColor = style.SelectFillColor
    }

    let image = getGraphicName(style, radius, style.fillColor, style.fillOpacity, style.strokeColor, style.strokeOpacity, style.strokeWidth)

    let styleObject

    if(select) {

        image = getGraphicName(style, style.SelectPointRadius, style.SelectFillColor, style.SelectFillOpacity, style.SelectStrokeColor, style.SelectStrokeOpacity, style.SelectStrokeWidth)

        styleObject =  new Style({
            fill: new Fill({
                color: 'rgba(' + hexToRgba(style.SelectFillColor, style.SelectFillOpacity) + ')'
            }),
            stroke: new Stroke({
                color: 'rgba(' + hexToRgba(style.SelectStrokeColor, style.SelectStrokeOpacity) + ')',
                width: style.SelectStrokeWidth,
            }),
            image: image
        })

        if(style.SelectLabel) {
            const text = new Text({
                text: style.SelectLabel.toString(),
                stroke: new Stroke({
                    color: 'rgba(' + hexToRgba(style.SelectLabelOutlineColor, 1) + ')',
                    width: style.SelectLabelOutlineWidth,
                }),
                fill: new Fill({
                    color: 'rgba(' + hexToRgba(style.SelectFontColor, 1) + ')',
                }),
                offsetX: style.SelectLabelXOffset,
                offsetY: style.SelectLabelYOffset,
                scale: style.SelectFontSize / 5,
                overflow: !style.SelectLabelOverflow
            })

            styleObject.setText(text)
        }

    } else {

        styleObject =  new Style({
            fill: new Fill({
                color: 'rgba(' + hexToRgba(style.fillColor, style.fillOpacity) + ')'
            }),
            stroke: new Stroke({
                color: 'rgba(' + hexToRgba(style.strokeColor, style.strokeOpacity) + ')',
                width: style.strokeWidth,
            }),
            image: image
        })

        if(style.label) {

            // console.log(style.labelOverflow)

            styleObject.setText(new Text({
                text: style.label.toString(),
                stroke: new Stroke({
                    color: 'rgba(' + hexToRgba(style.labelOutlineColor, 1) + ')',
                    width: style.labelOutlineWidth,
                }),
                fill: new Fill({
                    color: 'rgba(' + hexToRgba(style.fontColor, 1) + ')',
                }),
                offsetX: style.labelXOffset,
                offsetY: style.labelYOffset,
                scale: style.fontSize / 5,
                overflow: !style.labelOverflow
            }))
        }
    }





    return styleObject
}

export function getGraphicName(style, radius, fillColor, fillOpacity, strokeColor, strokeOpacity, strokeWidth) {
    let image
    let imageStyle = {
        fill: new Fill({
            color: 'rgba(' + hexToRgba(fillColor, fillOpacity) + ')'
        }),
        stroke: new Stroke({
            color: 'rgba(' + hexToRgba(strokeColor, strokeOpacity) + ')',
            width: strokeWidth,
        }),
        radius: radius,
    }

    switch (style.graphicName) {
        case 'cross':
            image = new RegularShape({
                fill: imageStyle.fill,
                stroke: imageStyle.stroke,
                radius: radius,
                radius2: 0,
                points: 4,
                angle: 0,
            })
            break;
        case 'x':
            image = new RegularShape({
                fill: imageStyle.fill,
                stroke: imageStyle.stroke,
                radius: radius + 10,
                points: 4,
                radius2: 6,
                angle: Math.PI / 4,
            })
            break;
        case 'square':
            image = new RegularShape({
                fill: imageStyle.fill,
                stroke: imageStyle.stroke,
                radius: radius,
                points: 4,
                angle: Math.PI / 4,
            })
            break;
        case 'triangle':
            image = new RegularShape({
                fill: imageStyle.fill,
                stroke: imageStyle.stroke,
                radius: radius,
                points: 3,
                angle: 0,
                rotation: Math.PI / 4,
            })
            break;
        case 'circle':
        default:
            image = new CircleStyle(imageStyle)
            break;
    }

    return image
}
